import * as base from './standard.theme';
import { font } from './fonts';
import light, { bg, JBTColors } from './light.theme';
import * as effects from './effects';
import { gridLines, ticks } from './charts';

export const styledTheme = {
  effects,
  JBTColors,
  colors: light,
  font,
  gridLines,
  ticks,
  ...base,
  bg: bg
};
export default styledTheme;
